<div
    class="font-inter w-full h-full bg-[linear-gradient(359deg,_#FFF_83.33%,_var(--latte-50,_#F9F5F0)_99.08%)]">
    <div class="w-full h-full p-4">
        <div class="flex flex-col items-center justify-between h-full">
            <div class="flex flex-col items-center justify-start gap-4 w-full">
                @if (panelOpen) {
                    @let user = userService.currentUser | async;
                    @if (user.userId) {
                        <div class="flex flex-col items-start justify-start w-full">
                            <fm-avatar size="lg" class="mb-2" [avatarLocation]="user.photo" />
                            <div
                                class="w-full text-left mr-auto font-inter text-base leading-normal font-semibold text-bluegrey-2 mb-1 wrap-double-line-el"
                                >Good morning,<br />{{ user.firstName }}!</div
                            >
                            <div class="text-12 leading-[normal] text-bluegrey-2 font-light">
                                {{ user.compSessions.toLocaleString('en-US') }}
                                {{
                                    user.compSessions > 1 || user.compSessions == 0
                                        ? 'sessions'
                                        : 'session'
                                }}
                            </div>
                        </div>
                    }
                    <div class="flex flex-col gap-2 w-full">
                        <p-button
                            (click)="onClickYourSchedule()"
                            severity="secondary"
                            class="w-full"
                            classes="w-full"
                            styleClass="w-full">
                            <div class="w-full flex items-center justify-between">
                                <div
                                    ><i class="pi pi-calendar" style="font-size: 14px"></i
                                    ><span class="ml-1 font-semibold">My Schedule</span>
                                </div>
                                <div class="flex items-center justify-center"
                                    ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                                ></div>
                            </div>
                        </p-button>
                        <p-button
                            (click)="onClickFavoritesSchedule()"
                            severity="secondary"
                            class="w-full"
                            classes="w-full"
                            styleClass="w-full">
                            <div class="w-full flex items-center justify-between">
                                <div
                                    ><i class="pi pi-star-fill" style="font-size: 14px"></i
                                    ><span class="ml-1 font-semibold">Favorites Availability</span>
                                </div>
                                <div class="flex items-center justify-center"
                                    ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                                ></div>
                            </div>
                        </p-button>
                    </div>
                } @else {
                    <div class="flex flex-col gap-2">
                        <p-button
                            (click)="onClickYourSchedule(true)"
                            size="small"
                            severity="secondary"
                            [outlined]="true"
                            styleClass="aspect-square"
                            icon="pi pi-calendar" />

                        <p-button
                            size="small"
                            styleClass="aspect-square"
                            severity="secondary"
                            [outlined]="true"
                            icon="pi pi-star-fill" />
                    </div>
                }
            </div>

            <!-- Bottom -->
            <div class="flex flex-col items-center justify-start gap-2 w-full">
                @if (panelOpen) {
                    <a
                        class="w-full"
                        href="https://tally.so/r/mVxDDJ"
                        target="_blank"
                        rel="noopener">
                        <p-button
                            severity="secondary"
                            class="w-full"
                            classes="w-full"
                            styleClass="w-full">
                            <div class="w-full flex items-center justify-start">
                                <div
                                    ><i class="pi pi-send" style="font-size: 14px"></i
                                    ><span class="ml-1 font-semibold">Feedback</span>
                                </div>
                            </div>
                        </p-button></a
                    >
                    <p-button
                        [routerLink]="'/session/' + (userService.currentUser | async).userId"
                        severity="secondary"
                        class="w-full"
                        classes="w-full"
                        styleClass="w-full">
                        <div class="w-full flex items-center justify-start">
                            <div>
                                <i class="pi pi-video" style="font-size: 14px"></i>
                                <span class="ml-1 font-semibold">Test audio and video</span>
                            </div>
                        </div>
                    </p-button>
                } @else {
                    <a
                        class="w-full"
                        href="https://tally.so/r/mVxDDJ"
                        target="_blank"
                        rel="noopener">
                        <p-button
                            size="small"
                            severity="secondary"
                            [outlined]="true"
                            styleClass="aspect-square"
                            icon="pi pi-send"
                    /></a>

                    <p-button
                        [routerLink]="'/session/' + (userService.currentUser | async).userId"
                        size="small"
                        severity="secondary"
                        [outlined]="true"
                        styleClass="aspect-square"
                        icon="pi pi-video" />
                }
            </div>
        </div>
    </div>
</div>
